import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import SliderPlugin from './SliderPlugin/SliderPlugin'

const FoodModeling = () => {
  return (
    <>
      <Card className='food-modeling-container no-border rounded-0 container'>
        <Card.Body>
            <Card.Title className='food-modeling-title py-1'>Food Modeling</Card.Title>
            <Card.Text className='food-modeling-text py-1'>
            Food can work the same way. Hiring a “food stylist,” as they’re known, is expensive and they’re hard to find. But digital food mockups can be just as mouth - watering as photos, and you get to control the placement of each element, down to the last sesame se ed. Food photo replacements can be used on websites, in menus, in advertising, for in - store signage, and so much more. In fact, we are now providing 3D food models for AR previews of menu items that can be viewed by you and your dining companions resulting in higher sales and satisfaction.
            </Card.Text>
        </Card.Body>
        <Row className='food-renderer-box'>
            <Col sm={6} md={5}>
                <Card className='no-border rounded-0'>
                    <Card.Body>
                        <Card.Title className='food-modeling-render-title'> 3D Burger Render </Card.Title>
                            <div className='burger-section'>
                                <video className='burger-player' autoPlay muted loop playsInline onContextMenu={(e) => e.preventDefault()}>
                                    <source src={process.env.PUBLIC_URL + "assets/food/burger/Burger_Render.mp4"} type="video/mp4"/>
                                </video>
                            </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} md={7}>
                <Card className='no-border rounded-0'>
                    <Card.Body>
                        <Card.Title className='food-modeling-render-title'> 3D Pizza Render </Card.Title>
                        <div className="pizza-section ">
                            <SliderPlugin data={1} />
                            {/* <img className="img-fluid pizza-image" src={process.env.PUBLIC_URL + "assets/food/pizza/Diffuse.jpg"} alt="Diffuse" /> */}
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
      </Card>
    </>
  )
}

export default FoodModeling
